export function initPromoCode() {
    const button =
        document.querySelector("#apply-promo");

    const promoInput =
        document.querySelector("#promo_code");

    const errorMessage =
        document.querySelector("#validation-error-msg");

    const promoMessage =
        document.querySelector("#promo-msg");

    const cartTotal =
        document.querySelector("#cart-total");

    const cartSubTotal =
        document.querySelector("#cart-sub-total");

    if (!button || !promoInput) {
        return;
    }


    async function applyPromo() {
        const csrfInput =
            document.querySelector(
                'input[name="csrf_gq_name"]'
            );

        const csrfToken =
            csrfInput?.value || "";

        const url =
            button.dataset.url;

        if (!url) {
            console.error(
                "Promo code URL is missing."
            );

            return;
        }


        const formData =
            new URLSearchParams();

        formData.append(
            "promo_code",
            promoInput.value.trim()
        );

        formData.append(
            "csrf_gq_name",
            csrfToken
        );


        button.disabled = true;


        try {
            const response =
                await fetch(url, {
                    method: "POST",

                    headers: {
                        "Content-Type":
                            "application/x-www-form-urlencoded; charset=UTF-8",

                        "X-Requested-With":
                            "XMLHttpRequest"
                    },

                    body:
                        formData.toString()
                });


            if (!response.ok) {
                throw new Error(
                    `Promo request failed with status ${response.status}`
                );
            }


            const data =
                await response.json();


            const total =
                `$${data.total_due}`;


            if (cartTotal) {
                cartTotal.textContent =
                    total;
            }


            if (cartSubTotal) {
                cartSubTotal.textContent =
                    total;
            }


            if (data.success) {
                errorMessage
                    ?.classList
                    .remove("d-block");


                if (errorMessage) {
                    errorMessage.textContent =
                        "";
                }


                if (promoMessage) {
                    promoMessage.innerHTML =
                        data.promo_msg || "";
                }

                return;
            }


            if (promoMessage) {
                promoMessage.innerHTML =
                    "";
            }


            if (errorMessage) {
                errorMessage.textContent =
                    data.error_msg ||
                    "Unable to apply promo code.";

                errorMessage.classList.add(
                    "d-block"
                );
            }
        } catch (error) {
            console.error(
                "Unable to apply promo code:",
                error
            );


            if (errorMessage) {
                errorMessage.textContent =
                    "Unable to apply promo code. Please try again.";

                errorMessage.classList.add(
                    "d-block"
                );
            }
        } finally {
            button.disabled = false;
        }
    }


    /*
    |--------------------------------------------------------------------------
    | Apply button
    |--------------------------------------------------------------------------
    */

    button.addEventListener(
        "click",
        applyPromo
    );

    promoInput.addEventListener(
    "keydown",
    (event) => {
        if (event.key !== "Enter") {
            return;
        }

        event.preventDefault();

        applyPromo();
    }
);

    /*
    |--------------------------------------------------------------------------
    | Apply an existing promo automatically
    |--------------------------------------------------------------------------
    */

    if (promoInput.value.trim()) {
        applyPromo();
    }
}